import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
;
import { Button, Card, CardContent, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import dayjs from 'dayjs-ext';
import classNames from 'classnames';
import { toast } from 'react-toastify';
import { find, get } from 'lodash';
import { getUser } from 'src/user';
import { OnChange } from 'react-final-form-listeners';
import {
  setBreadcrumbs,
  UiSelectAdapter,
  UiInputAdapter,
  InnerLoader,
  UiDatePickerAdapter,
  SaveChangesToast,
  ConfirmChangesModal,
  reduceServerErrors,
  UiToastAdapter,
  UiImageUploaderAdapter,
  UiFieldset,
  AddressPickerAdapter,
  getLicenseTypes,
  maskPhone,
  UiToggleAdapter,
  UiTooltip,
  UiQuillAdapter,
} from 'src/ui';

import {
  getAccount,
  fetchAccount,
  fetchFormData,
  getFormData,
  addAccountLocation,
  updateAccountLocation,
  setLocationLicenseImages,
} from 'src/account';
import { usStates } from 'src/core';
import { ZIP_MASK, PHONE_MASK } from 'src/ui/const';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { composeValidators, required, email, url } from 'src/ui/validations';
import createDecorator from 'final-form-calculate';
import { DirectionsModal } from '../components';

const formCalculator = createDecorator({
  field: 'autocompleteAddress',
  updates: {
    address: value => get(value, 'address'),
    city: value => get(value, 'city'),
    state: value => find(usStates, { value: get(value, 'state') }),
    zipCode: value => get(value, 'zipCode'),
  },
});

class LocationsEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      title: '',
      initialValues: {},
      confirmChangesModal: false,
      selectedState: '',
      directionsModal: false,
    };
  }

  async componentDidMount() {
    const { match, fetchFormData, setBreadcrumbs, fetchAccount } = this.props;
    const { id } = match.params;
    const title = id ? 'Edit' : 'Add';

    this.setState({ title });

    setBreadcrumbs([
      { label: 'Locations', href: '/locations' },
      { label: title, href: match.url },
    ]);

    const { user } = this.props;
    const fiId = user.financialInstitutionId || user.fiSelectedAccountId;

    if (fiId) {
      await Promise.all([
        fetchAccount(user.accountId),
        fetchFormData(fiId, user.accountId),
      ]);

      if (id) {
        this.buildData(+id);
      }
    }

    this.setState({ loading: false });
  }

  get licenseTypes() {
    const { account, formData } = this.props;
    return getLicenseTypes(account, formData);
  }

  async setLicenseImages(locationId, imageFront, imageBack) {
    const { user, setLocationLicenseImages } = this.props;
    await setLocationLicenseImages({
      accountId: user.accountId,
      locationId,
      imageFront:
        imageFront != null && typeof imageFront === 'string'
          ? null
          : imageFront,
      imageBack:
        imageBack != null && typeof imageBack === 'string' ? null : imageBack,
    });
    const { account } = this.props;
    if (account.isError()) {
      return reduceServerErrors(account);
    }
    toast(UiToastAdapter('License images uploaded successfully!', 'success'));
    return undefined;
  }

  handleSubmit = async values => {
    const { match } = this.props;
    const { id } = match.params;
    if (id) {
      await this.updateLocation(id, values);
    } else {
      await this.addLocation(values);
    }
    this.setState({
      initialValues: values,
    });
  };

  showModal = () => {
    this.toggleModal(true);
  };

  hideModal = () => {
    this.toggleModal(false);
  };

  toggleState = value => {
    this.setState({ selectedState: value });
  };

  toggleDirections = () => {
    this.setState(prevState => ({
      directionsModal: !prevState.directionsModal,
    }));
  };

  async addLocation(formValues) {
    const { addAccountLocation, user } = this.props;
    const { licenseImageFront, licenseImageBack, ...values } = formValues;

    const result = await addAccountLocation({
      ...values,
      accountId: user.accountId,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }

    const locationId = result.payload.id;

    if (
      (licenseImageBack != null && typeof licenseImageBack !== 'string') ||
      (licenseImageFront != null && typeof licenseImageFront !== 'string')
    ) {
      toast(
        UiToastAdapter('Location added, sending license images...', 'info')
      );
      return this.setLicenseImages(
        locationId,
        licenseImageFront,
        licenseImageBack
      );
    }

    toast(UiToastAdapter('Location added', 'success'));
    return undefined;
  }

  async updateLocation(id, formValues) {
    const { updateAccountLocation, user } = this.props;
    const { licenseImageFront, licenseImageBack, ...values } = formValues;
    const { initialValues } = this.state;

    // Include image fields in the update to handle deletion
    // If image is a File object, it will be sent separately via setLicenseImages
    // If image was cleared (null, undefined, or empty string) and was previously set, send null to delete it
    // If image is still a string (existing URL unchanged), don't send it (preserve existing)
    const updateValues = { ...values };
    
    // Handle front image: send null if cleared from initial value
    if (
      (licenseImageFront == null || licenseImageFront === '') &&
      initialValues?.licenseImageFront != null &&
      initialValues?.licenseImageFront !== ''
    ) {
      updateValues.location_license_image_front = null;
    }
    
    // Handle back image: send null if cleared from initial value
    if (
      (licenseImageBack == null || licenseImageBack === '') &&
      initialValues?.licenseImageBack != null &&
      initialValues?.licenseImageBack !== ''
    ) {
      updateValues.location_license_image_back = null;
    }

    await updateAccountLocation({
      ...updateValues,
      accountId: user.accountId,
      locationId: id,
    });

    const { account } = this.props;

    if (account.isError()) {
      return reduceServerErrors(account);
    }
    if (
      (licenseImageBack != null && typeof licenseImageBack !== 'string') ||
      (licenseImageFront != null && typeof licenseImageFront !== 'string')
    ) {
      toast(
        UiToastAdapter('Location updated, sending license images...', 'info')
      );
      return this.setLicenseImages(id, licenseImageFront, licenseImageBack);
    }
    toast(UiToastAdapter('Location updated', 'success'));
    return undefined;
  }

  buildData(id) {
    const { account, formData } = this.props;
    const location = find(account.locations, { id });

    if (location) {
      const initialValues = {
        ...location,
        addressType: find(formData.addressTypes, { id: location.typeId }),
        state: find(usStates, { value: location.state }),
        licenseType: location.licenseType
          ? find(this.licenseTypes, { id: location.licenseType })
          : null,
        licenseDateIssued: location.licenseIssuedDate
          ? dayjs(location.licenseIssuedDate)
              .utc()
              .toDate()
          : null,
        licenseDateExpired: location.licenseExpiredDate
          ? dayjs(location.licenseExpiredDate)
              .utc()
              .toDate()
          : null,
        varSheetIssuedDate: location.varSheetIssuedDate
          ? dayjs(location.varSheetIssuedDate)
              .utc()
              .toDate()
          : null,

        phoneNumber: location.phoneNumber
          ? maskPhone(location.phoneNumber)
          : null,
        location_notes: location.location_notes || '',
      };
      this.setState({ initialValues });
    }
  }

  toggleModal(value) {
    this.setState({ confirmChangesModal: value });
  }

  render() {
    const {
      formData,
      isExpanded,
      user: { financialInstitutionForPayments, isBankAdmin, isSuperAdmin },
    } = this.props;
    const {
      title,
      initialValues,
      loading,
      confirmChangesModal,
      selectedState,
      directionsModal,
    } = this.state;

    const toastContainerClassName = classNames('bottom-toast-container', {
      'is-condensed': !isExpanded,
    });

    return (
      <>
        <MuiTitle isSize="4" hasTextColor="info" tag="h2">
          {`${title} Location`}
          <NavLink
            className="close-page button is-small is-text is-pulled-right"
            to="/locations"
          >
            <span className="icon has-text-danger">
              <FontAwesomeIcon icon={['fal', 'times-circle']} size="2x" />
            </span>
          </NavLink>
        </MuiTitle>

        <Form
          onSubmit={this.handleSubmit}
          decorators={[formCalculator]}
          subscription={{
            submitting: true,
            dirty: true,
            hasValidationErrors: true,
            dirtySinceLastSubmit: true,
          }}
          initialValues={initialValues}
          render={({
            handleSubmit,
            submitting,
            hasValidationErrors,
            dirty,
            dirtySinceLastSubmit,
          }) => (
            <Card tag="form" noValidate onSubmit={handleSubmit}>
              <CardContent>
                <div className={toastContainerClassName}>
                  <SaveChangesToast
                    message="Click the button to the right to save your changes"
                    isLoading={submitting}
                    isDisabled={submitting || hasValidationErrors}
                    isVisible={dirty || dirtySinceLastSubmit}
                    onClickButton={this.showModal}
                  />
                </div>
                <ConfirmChangesModal
                  title="Location"
                  isActive={confirmChangesModal}
                  onClickCancel={this.hideModal}
                  onClickSubmit={this.hideModal}
                />
                {directionsModal && (
                  <DirectionsModal
                    isActive={directionsModal}
                    onCancel={this.toggleDirections}
                    state={
                      directionsModal ? selectedState.value || 'CO' : undefined
                    }
                  />
                )}
                <InnerLoader visible={submitting || loading} />
                <UiFieldset title="Address" isFirst>
                  <Columns isMultiline>
                    <Column isSize="full">
                      <Field
                        component={AddressPickerAdapter}
                        label="Search Address"
                        name="autocompleteAddress"
                        id="autocompleteAddress"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiSelectAdapter}
                        name="addressType"
                        id="addressType"
                        required
                        options={formData.addressTypes}
                        label="Address Type"
                        getOptionLabel={item => item.name}
                        getOptionValue={item => item.id}
                        validate={composeValidators('Address Type', required)}
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="address"
                        id="address"
                        required
                        label="Location Address"
                        validate={composeValidators(
                          'Location Address',
                          required
                        )}
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="address2"
                        id="address2"
                        label="Location Address 2"
                      />
                    </Column>

                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="city"
                        id="city"
                        required
                        label="City"
                        validate={composeValidators('City', required)}
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiSelectAdapter}
                        name="state"
                        id="state"
                        required
                        options={usStates}
                        label="State"
                        validate={composeValidators('State', required)}
                      />
                      <OnChange name="state">
                        {value => {
                          this.toggleState(value);
                        }}
                      </OnChange>
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="zipCode"
                        id="zipCode"
                        label="Zip Code"
                        required
                        mask={ZIP_MASK}
                        validate={composeValidators('Zip Code', required)}
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
                <UiFieldset
                  title="Contact Information"
                  tooltip="Optional if different than primary business contact"
                >
                  <Columns isMultiline>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="phoneNumber"
                        id="phoneNumber"
                        label="Phone number"
                        mask={PHONE_MASK}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'phone']} />
                          </span>,
                        ]}
                        hasIcons="right"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="dba"
                        id="dba"
                        label="Location Name"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="email"
                        id="email"
                        label="E-mail address"
                        type="email"
                        validate={composeValidators('E-mail address', email)}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'envelope']} />
                          </span>,
                        ]}
                        hasIcons="right"
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
                <UiFieldset
                  title="Social Media"
                  tooltip="Optional if different than primary business social media"
                >
                  <Columns isMultiline>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="facebook"
                        id="facebook"
                        validate={composeValidators('Facebook', url)}
                        label="Facebook"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="linkedin"
                        id="linkedin"
                        validate={composeValidators('Linkedin', url)}
                        label="Linkedin"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="twitter"
                        id="twitter"
                        validate={composeValidators('Twitter', url)}
                        label="Twitter"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="instagram"
                        id="instagram"
                        validate={composeValidators('Instagram', url)}
                        label="Instagram"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
                <UiFieldset title="Business License">
                  <Columns isMultiline>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiSelectAdapter}
                        name="licenseType"
                        id="licenseType"
                        options={this.licenseTypes}
                        label="License Type"
                        getOptionLabel={item => item.name}
                        getOptionValue={item => item.id}
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="licenseNumber"
                        id="licenseNumber"
                        label="License Number"
                      />
                    </Column>
                    {(isBankAdmin || isSuperAdmin) &&
                      financialInstitutionForPayments && (
                        <Column isSize="narrow">
                          <Field
                            component={UiToggleAdapter}
                            id="licenseCheckToggle"
                            name="licenseCheckToggle"
                            type="checkbox"
                          >
                            Enable license checks
                            <UiTooltip content="This location will be enabled for license checks" />
                          </Field>
                        </Column>
                      )}
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiDatePickerAdapter}
                        name="licenseDateIssued"
                        id="licenseDateIssued"
                        label="Date Issued"
                        maxDate={dayjs()
                          .startOf('day')
                          .toDate()}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        hasIcons="right"
                        renderIcons={() => [
                          <span className="icon is-right" key="right-icon">
                            <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                          </span>,
                        ]}
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiDatePickerAdapter}
                        name="licenseDateExpired"
                        id="licenseDateExpired"
                        label="Date Expired"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        hasIcons="right"
                        renderIcons={() => [
                          <span className="icon is-right" key="right-icon">
                            <FontAwesomeIcon icon={['fal', 'calendar-alt']} />
                          </span>,
                        ]}
                      />
                    </Column>
                    <Column />
                    {/* <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="licenseURL"
                        id="licenseURL"
                        validate={composeValidators('licenseURL', url)}
                        label="Link to License"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column>
                    <Column isSize="1/2" className="is-one-third-fullhd">
                      <Field
                        component={UiInputAdapter}
                        name="consentURL"
                        id="consentURL"
                        validate={composeValidators('consentURL', url)}
                        label="Link to Consent"
                        disabled={submitting}
                        renderIcons={() => [
                          <span
                            className="icon is-small is-right"
                            key="right-icon"
                          >
                            <FontAwesomeIcon icon={['fal', 'link']} />
                          </span>,
                        ]}
                        hasIcons="right"
                        type="url"
                      />
                    </Column> */}
                    <Column
                      isSize="full"
                      className="is-paddingless is-marginless"
                    />

                    <Column isSize="narrow">
                      <Field
                        component={UiImageUploaderAdapter}
                        name="licenseImageFront"
                        id="licenseImageFront"
                        label="License Image (Front)"
                        type="file"
                      />
                    </Column>
                    <Column isSize="narrow">
                      <Field
                        component={UiImageUploaderAdapter}
                        name="licenseImageBack"
                        id="licenseImageBack"
                        label="License Image (Back)"
                        type="file"
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
                <UiFieldset title="Notes">
                  <Columns isMultiline>
                    <Column isSize="full">
                      <Field
                        component={UiQuillAdapter}
                        name="location_notes"
                        id="location_notes"
                        label="Location Notes"
                        placeholder="Add any additional notes about this location..."
                      />
                    </Column>
                  </Columns>
                </UiFieldset>
                {selectedState.value === 'CO' && (
                  <UiFieldset title="Regulatory" tooltip="metrc key">
                    <Columns>
                      <Column isSize="1/2" className="is-one-third-fullhd">
                        <Field
                          component={UiInputAdapter}
                          name="apiKey"
                          id="apiKey"
                          label="API Key"
                        />
                      </Column>
                      <Column isSize="1/2" className="is-one-third-fullhd">
                        <Button
                          isColor="gradient-bright"
                          onClick={this.toggleDirections}
                        >
                          {selectedState
                            ? `How to generate key for ${selectedState.label}...`
                            : 'Select State For Directions'}
                        </Button>
                      </Column>
                    </Columns>
                  </UiFieldset>
                )}
              </CardContent>
            </Card>
          )}
        />
      </>
    );
  }
}

LocationsEditPage.propTypes = {
  match: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  formData: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchFormData: propTypes.func.isRequired,
  fetchAccount: propTypes.func.isRequired,
  addAccountLocation: propTypes.func.isRequired,
  updateAccountLocation: propTypes.func.isRequired,
  setLocationLicenseImages: propTypes.func.isRequired,
  isExpanded: propTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
    formData: getFormData(state),
    account: getAccount(state),
  };
}

const connectedLocationsEditPage = connect(mapStateToProps, {
  setBreadcrumbs,
  fetchFormData,
  fetchAccount,
  addAccountLocation,
  updateAccountLocation,
  setLocationLicenseImages,
})(LocationsEditPage);

export { connectedLocationsEditPage as LocationsEditPage };
